
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drill",
      function () {
        return require("private-next-pages/drill/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drill"])
      });
    }
  